<template>
  <v-col class="text-center">
    <div style="line-height: 1rem">
      <v-sheet
        large
        color="transparent"
        elevation="0"
        >{{ status }}</v-sheet
      ><br />
      <span
        >{{ updated }}</span
      >
    </div>
  </v-col>
</template>
<script>
export default {
  props: {
    status: String,
    updated: String,
  }
}
</script>
<style lang="scss" scoped>
.v-sheet {
  color: var(--v-secondaryAction-base);
  font-size: 1.5rem;
  font-weight: bold;
}
</style>